function progressBar(){
    // the progress bar
    var bar = document.getElementById('state-progress-bar');
    addEventListener('scroll', function() {
        var max = document.body.scrollHeight - innerHeight;
        var percent = (pageYOffset / max) * 100;
        bar.style.width = percent + '%';
    });
}

function openCloseMenu(){
  jQuery('#state-menuButton').click(function() {
      jQuery('body').toggleClass('state-menu--open');
      jQuery('#state-menuButton').toggleClass('state-menu-button--open');
  });
}

function animateQuotes(){
  // pullquote animation
    jQuery.each(['state-quote'], function(i, classname) {
        var jQueryelements = jQuery('.' + classname)
        jQueryelements.each(function() {
            new Waypoint({
                element: this,
                handler: function(direction) {
                    var previousWaypoint = this.previous()
                    var nextWaypoint = this.next()
                    if (direction === 'down') {
                        jQuery(this.element).addClass('state-quote--reveal');
                    }
                    else if (direction === 'up') {
                        jQuery(this.element).removeClass('state-quote--reveal');
                    }
                },
                offset: '50%',
                group: classname
            })
        });
    });
}

function inlineVideo(){
    jQuery('.inlineVideo').each(function () {
        enableInlineVideo(this);
    });
}

function embedAudio(){
    audiojs.events.ready(function() {
        var as = audiojs.createAll();
    });
}


$(document).ready(function() {
    // DOM ready
    animateQuotes();
    progressBar();
    openCloseMenu();
    inlineVideo();
    embedAudio();
});

$(window).load(function() {
    setTimeout(function() {
        jQuery('body').removeClass('preload');
        jQuery('body').addClass('state--loaded');

    }, 50);  
});
    